import React, { KeyboardEvent, useRef, useEffect } from 'react';
import { useChatWidgetContext } from '../../ChatWidgetContext';
import ContextChipList from './ContextChipList';
import StopGenerationButton from './StopGenerationButton';
import styles from '../ChatWidget.module.scss';

export default function MessageInput() {
  const {
    sendMessage,
    stopGeneration,
    isStreaming,
    inputText,
    setInputText,
    selectedContext,
    removeContext,
  } = useChatWidgetContext();

  const textareaRef = useRef<HTMLTextAreaElement>(null);

  useEffect(() => {
    if (textareaRef.current) {
      textareaRef.current.style.height = 'auto';
      textareaRef.current.style.height = `${Math.min(textareaRef.current.scrollHeight, 96)}px`;
    }
  }, [inputText]);

  const handleKeyDown = (e: KeyboardEvent<HTMLTextAreaElement>) => {
    if (e.key === 'Escape' && isStreaming) {
      e.preventDefault();
      stopGeneration();
    } else if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      sendMessage();
    }
  };

  const canSend = !isStreaming && inputText.trim().length > 0;

  return (
    <div className={styles.inputArea}>
      <div className={styles.inputContainer}>
        <textarea
          ref={textareaRef}
          className={styles.inputTextarea}
          placeholder="Ask anything..."
          value={inputText}
          onChange={(e) => setInputText(e.target.value)}
          onKeyDown={handleKeyDown}
          disabled={isStreaming}
          rows={1}
          data-testid="chat-message-input"
        />
        <div className={styles.inputButtonBar}>
          {selectedContext.length > 0 && (
            <div className={styles.inputContextChips}>
              <ContextChipList context={selectedContext} onRemove={removeContext} />
            </div>
          )}
          <StopGenerationButton />
          {!isStreaming && (
            <button
              type="button"
              className={`${styles.sendButton} ${canSend ? styles.sendButtonActive : ''}`}
              onClick={sendMessage}
              disabled={!canSend}
              data-testid="chat-send-button"
              title="Send message"
            >
              &#8593;
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
